import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { currentId: String };

  switch(event) {
    event.preventDefault();
    const newId = event.currentTarget.dataset.propertyId;
    const currentPath = window.location.pathname;

    if (
      this.currentIdValue &&
      currentPath.includes(`/properties/${this.currentIdValue}`)
    ) {
      // Replace the current property ID in the URL
      const newPath = currentPath.replace(
        `/properties/${this.currentIdValue}`,
        `/properties/${newId}`,
      );
      window.location.href = newPath;
    } else {
      // Not on a property-scoped page, go to property show
      window.location.href = `/properties/${newId}`;
    }
  }
}
